import React, { useState } from 'react'
import { MyToolIcons, NotificationIcons } from '../../global/Icons'

export const WebSiteNavState = () => {

    const [tabs, setTabs] = useState({
        top: [
            {name:'Notifications', className:'', subdir:'/notification', ref: '/notification', not_active: <NotificationIcons fill="#333333" />, active: <NotificationIcons fill="#107038" />},
            {name:'MyTools', step: 'mytools', className:'tenth-step', subdir:'#', ref: '__mytools', not_active:<MyToolIcons fill="#292D32" />, active:<MyToolIcons fill="#107038" stroke="#107038"/>},
        ],})

  return {
    tabs: {data: tabs, set: setTabs},
  }
   
  
}
